import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import * as LogisticUtility from '../../../Common/Utilties/LogisticUtility'

import EditIcon from '../../../../image/edit-icon.png'
import { MultipartApi } from '../../../Common/ApiAxios';
import { useDispatch } from 'react-redux'
import { SetLoadSpinner } from '../../../Common/Slice/LoadSpinnerSlice'
import { useAlert } from 'react-alert'
import Input from '../../../Common/Atoms/Input'

const DefaultUrl = '/api/masterManagement/makeShippingSchedule';

const MediaWrap = styled.div`
  width:1800px;
  display: flex; /* 横並び */
  flex-wrap: wrap;
  margin: 4px;
  box-shadow: 0 0 3px 2px ${props => props.selected ? 'rgba(0,128,0,0.8)' : 'rgba(0,0,0,0.4)'};

  color: #000;
  font-size: 16px;

  text-align: center;
  align-items: center;
`

const MediaItem = styled.div`
  display: flex; /* 縦並び */
  flex-direction: column;
  height: 40px;
  border-right: 2px dashed #fff;
`

const TextWrap = styled.div`
  margin: auto;
  text-overflow: ellipsis; /* 見切れ対策 */
  overflow: hidden;
  white-space: nowrap;
` 
const MediaLastItem = styled.div`
  display: flex; /* 縦並び */
  flex-direction: row;
  height: 40px;
`
const ScreenButton = styled.button`
  display: flex;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.05em;
  text-align: center;
  vertical-align: middle;
  color: ${props => props.activeState ? '#fff' : '#000'};
  background-color: ${props => props.activeState ? '#649CDF' : '#ccc'};
  width: 80px;
  height: 30px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  box-shadow: 1px 1px 3px 0 rgba(0,0,0,0.4), inset 0 2px 0 0 rgba(255,255,255,0.4);
`
const FunctionIcon = styled.img`
  width: 18px;
  height: 18px;
`

const SelectField = styled.select`
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const MaterialShippingCdItem= (props) => {
  const {
    data,onReSerach,baseId
  } = props
  const [isEdit,setIsEdit]= useState(false);
  const dispatch = useDispatch();
  const alert = useAlert();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editData, setEditData] = useState(
    {
      dstShippingCd: data.dstShippingCd,
      srcShippingCd: data.srcShippingCd,
    }
  );
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setEditData((prev) => ({ ...prev, [id]: value }));
  };

  // 初期値
  useEffect(() => {
    setEditData(
      {
        dstShippingCd: data.dstShippingCd,
        srcShippingCd: data.srcShippingCd,
      }
    )
  },[data])
  // `Clear` ロケーションの解除処理
  const handleClear =  async() => {
    var param =
    {
      baseId: baseId,
      srcShippingCd: editData.srcShippingCd,
      dstShippingCd: editData.dstShippingCd,
    }
    dispatch(SetLoadSpinner(true));
    const apiUrl = `${DefaultUrl}/clear/shippingCd`;
    console.log(param)
    const submitData = new window.FormData()
    submitData.append('formData', new window.Blob([JSON.stringify(param)], { type: 'application/json' }))
    const result = await MultipartApi(apiUrl,'PUT',submitData,param);
    dispatch(SetLoadSpinner(false));
    if(result.errorDetail)
    {
      alert.error('出荷先コードの変換の削除に失敗しました。');
    }else{
      alert.info('出荷先コードの変換の削除に成功しました。');
      onReSerach(true);
    }
  };
  // `Update` ロケーションの更新処理
  const handleUpdate =  async() => {
      var param =
      {
        baseId: baseId,
        srcShippingCd: editData.srcShippingCd,
        dstShippingCd: editData.dstShippingCd,
      }
      dispatch(SetLoadSpinner(true));
      const apiUrl = `${DefaultUrl}/"put/shippingCd`;
      console.log(param)
      const submitData = new window.FormData()
      submitData.append('formData', new window.Blob([JSON.stringify(param)], { type: 'application/json' }))
      const result = await MultipartApi(apiUrl,'PUT',submitData,param);
      dispatch(SetLoadSpinner(false));
      if(result.errorDetail)
      {
        alert.error('ロケーションの更新に失敗しました。');
      }else{
        alert.info('ロケーションの更新に成功しました。');
        onReSerach(true);
        setIsEdit(false);
      }
  };
  const onInsertLocaton = (e) => {
    setIsDialogOpen(true)
  }

  if (!data) return null;
  //console.log(data);
  return (
    <MediaWrap>
      {!isEdit &&
      <>
      <MediaItem>
        <TextWrap style={{width:'150px', textAlign:'left'}}>
          <div style={{marginLeft:'1rem'}}>{data.srcShippingCd}</div>
        </TextWrap>
      </MediaItem>
      <MediaItem>
        <TextWrap style={{width:'150px', textAlign:'left'}}>
          <div style={{marginLeft:'1rem'}}>{data.dstShippingCd}</div>
        </TextWrap>
      </MediaItem>
      </>
      }
      {isEdit &&
      <>
      <MediaItem>
        <TextWrap style={{width:'150px', textAlign:'left'}}>
          <Input 
            width={'140px'} 
            type="text"
            id="srcShippingCd"
            defaultValue={data.srcShippingCd}
            onChange={handleInputChange}
          />
        </TextWrap>
      </MediaItem>
      <MediaItem>
        <TextWrap style={{width:'150px', textAlign:'left'}}>
          <Input 
            width={'140px'} 
            type="text"
            id="dstShippingCd"
            defaultValue={data.dstShippingCd}
            onChange={handleInputChange}
          />
        </TextWrap>
      </MediaItem>
      </>
      }
      {!isEdit &&
      <MediaLastItem>
        <div style={{margin:'auto 0 auto 0.5rem'}}>
          <ScreenButton 
            name='削除' padding='0px' type="button" 
            onClick={handleClear} 
            activeState={!data.patternFlag && data.shippingCd} 
            disabled={!!data.patternFlag || !data.shippingCd}
          >
          <TextWrap style={{textAlign:'center'}}>
            <div>削除</div>
          </TextWrap>
          </ScreenButton>
        </div>
        <div style={{margin:'auto 0 auto 0.5rem'}}>
          <TextWrap style={{textAlign:'center' ,cursor:'pointer'}}>
            <FunctionIcon  
              alt='編集' 
              src={EditIcon} 
              disabled={!!data.patternFlag}
              onClick={()=>{setIsEdit(!data.patternFlag)}} 
            />
          </TextWrap>
        </div>
      </MediaLastItem>
      }
      {isEdit &&
      <MediaLastItem>
        <div style={{margin:'auto 0 auto 0.5rem'}}>
          <ScreenButton 
            name='キャンセル' padding='0px' type="button"  
            onClick={()=>setIsEdit(false)} 
            activeState={true} 
          >
          <TextWrap style={{textAlign:'center'}}>
            <div>キャンセル</div>
          </TextWrap>
          </ScreenButton>
        </div>
        <div style={{margin:'auto 0 auto 0.5rem'}}>
          <ScreenButton 
            name='更新' padding='0px' type="button" 
            activeState={!data.patternFlag} 
            disabled={!!data.patternFlag}
            onClick={handleUpdate}
          >
          <TextWrap style={{textAlign:'center'}}>
            <div>更新</div>
          </TextWrap>
          </ScreenButton>
        </div>
      </MediaLastItem>
      }
    </MediaWrap>
  )
}

MaterialShippingCdItem.propTypes = {
  data: PropTypes.object, // ダイアログ
}

export default MaterialShippingCdItem
